export const load = () => ({
	title: 'Energy Efficiency For Historic Windows',
	h1: 'Preserve Historic Windows with Indow Inserts',
	description:
		'Upgrade your historic windows without replacing them. Indow inserts add energy efficiency and noise reduction to your existing windows.',
	showTitle: true,
});
